import { render, staticRenderFns } from "./DualCTA.vue?vue&type=template&id=88bd0ac0"
import script from "./DualCTA.vue?vue&type=script&lang=js"
export * from "./DualCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports